import React, { useState, useEffect } from 'react';
import ModalCustom from '../../design/shared/modal';
import { Button, Typography } from '@telus-uds/components-web';
import PropTypes from 'prop-types';
import axios from 'axios';
import _ from 'lodash';
// import TypeAhead from '../../defectManagement/typeAhead';
import { Typeahead } from 'react-bootstrap-typeahead';
import { ModalBox } from '../../defectManagement/css';
import { apiHost, config as axiosConfig } from '../../utils/request';

const SalesRepSelectionModal = ({ 
  isVisible, 
  onClose, 
  onSelect, 
  currentOrder,
  staticLabels 
}) => {
  const [salesReps, setSalesReps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSalesRep, setSelectedSalesRep] = useState([]);
  useEffect(() => {
    if (isVisible) {
      setLoading(true);
      axios.get(`${apiHost}/users/sales-reps`, axiosConfig())
        .then(response => {
          const reps = _.get(response, 'data.salesReps', []);
          setSalesReps(reps.map(rep => ({
            id: rep.id,
            label: `${rep.firstName} ${rep.lastName} (${rep.email})`,
            email: rep.email,
            ...rep
          })));
        })
        .finally(() => setLoading(false));
    }
  }, [isVisible]);

  const handleSalesRepSelect = (selected) => {
    setSelectedSalesRep(selected);
  };

  const handleConfirm = () => {
    if (selectedSalesRep.length && currentOrder) {
      const selectedRep = selectedSalesRep[0];
      // Save selected sales rep details in orderData
      currentOrder.orderCreatedBy = {
      ...selectedRep
      };
      currentOrder.loggedInUserDetail = {
       ...selectedRep
      };
      currentOrder.assignedUserId = selectedRep.id; 
      currentOrder.orderAssignedTo = selectedRep.id;
      currentOrder.createdBy = selectedRep.id;
      onSelect(currentOrder, selectedRep);
      onClose();
      setSelectedSalesRep([]);
    }
  };

  return (
    <ModalCustom
      open={isVisible}
      setOpen={onClose}
      header={staticLabels && staticLabels.reassignOrder ? staticLabels.reassignOrder : 'Reassign Order'}
      customStyles={{ height: '450px' }}
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          {(staticLabels && staticLabels.loading) ? staticLabels.loading : 'Loading sales representatives...'}
        </div>
      ) : (
        <>
          <Typography variant={{ bold: true }}>{staticLabels && staticLabels.selectSalesRep ? staticLabels.selectSalesRep : 'Choose Sales Rep from the list'}</Typography>
          <Typeahead
            label={staticLabels && staticLabels.selectSalesRep ? staticLabels.selectSalesRep : 'Choose Sales Rep from the list'}
            onChange={handleSalesRepSelect}
            options={salesReps}
            selected={selectedSalesRep}
            placeholder={staticLabels && staticLabels.unassigned ? staticLabels.unassigned : 'Select Sales Rep'}
          />
          <ModalBox>
            <Button
              onClick={handleConfirm}
              disabled={!selectedSalesRep.length}
            >
              {(staticLabels && staticLabels.confirm) ? staticLabels.confirm : 'Confirm'}
            </Button>
          </ModalBox>
        </>
      )}
    </ModalCustom>
  );
};

SalesRepSelectionModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  currentOrder: PropTypes.object,
  staticLabels: PropTypes.object
};

export default SalesRepSelectionModal;